import { useEffect, useState } from "react";
import api from "@/lib/api";

export const STATUS_META = {
  available: { label: "Available", cls: "bg-[#CCFF00] text-black border-[#CCFF00]" },
  blocked: { label: "Unavailable", cls: "bg-[#3A0A0A] text-[#FF6B6B] border-[#FF4D4D] line-through" },
  negotiable: { label: "Negotiable", cls: "bg-[#1A1A1A] text-[#B0B0B0] border-[#333]" },
};

export async function fetchCoachDayStatus(coachId, start, end) {
  const qs = start ? `?start=${start}&end=${end || start}` : "?days=42";
  const { data } = await api.get(`/public/coaches/${coachId}/day-status${qs}`);
  return data.days || [];
}

export function requestStatusFromDays(days) {
  const vals = new Set(days.map((d) => d.status));
  if (!vals.size) return "negotiable";
  if (vals.size === 1 && vals.has("blocked")) return "blocked";
  if (vals.size === 1 && vals.has("available")) return "available";
  return "negotiable";
}

export function CoachAvailabilityCalendar({ coachId }) {
  const [days, setDays] = useState([]);
  useEffect(() => {
    fetchCoachDayStatus(coachId).then(setDays).catch(() => setDays([]));
  }, [coachId]);
  if (!days.length) return null;
  const lead = (new Date(`${days[0].date}T00:00:00Z`).getUTCDay() + 6) % 7;
  return (
    <div className="card-surface p-6" data-testid="coach-availability-calendar">
      <div className="label-mono mb-3">AVAILABILITY · NEXT 6 WEEKS</div>
      <div className="grid grid-cols-7 gap-1 text-[10px] text-[#B0B0B0] mb-1">
        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((d) => <div key={d} className="text-center">{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {Array.from({ length: lead }).map((_, i) => <div key={`pad-${i}`} />)}
        {days.map((d) => (
          <div key={d.date} title={`${d.date} · ${STATUS_META[d.status].label}`}
            data-testid={`coach-day-${d.date}`} data-status={d.status}
            className={`border text-center py-1.5 text-xs font-mono ${STATUS_META[d.status].cls}`}>
            {Number(d.date.slice(8, 10))}
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 mt-3 text-[11px]">
        {Object.entries(STATUS_META).map(([k, m]) => (
          <span key={k} className="inline-flex items-center gap-1.5">
            <span className={`w-3 h-3 border ${m.cls}`} /> <span className="text-[#E0E0E0]">{m.label}</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default CoachAvailabilityCalendar;
